import cn from 'classnames';
import React, {FC} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import useIsHeaderHidden from '../../hooks/useIsHeaderHidden';
import {selectNotifications} from '../../state/selectors/global';
import Notification from './Notification/Notification';
import {INotification} from './Notification/NotificationTypes';

const mapStateToProps = createStructuredSelector({
    notifications: selectNotifications,
});

interface IProps {
    notifications: INotification[];
}

const Notifications: FC<IProps> = (props) => {
    const {notifications} = props;

    const isNotificationShown = notifications.length > 0;
    const isHeaderHidden = useIsHeaderHidden(isNotificationShown);

    return notifications.length ? (
        <div className={cn('fixed z-[160] w-full md:max-w-[536px] lg:max-w-[724px]', {'top-0': isHeaderHidden})}>
            <div className='sticky left-0 top-0 m-auto flex justify-center px-4 pt-4'>
                <div className='flex w-full flex-col items-center gap-3'>
                    {notifications.map((notification) => (
                        <Notification key={notification.notificationId} notification={notification} />
                    ))}
                </div>
            </div>
        </div>
    ) : null;
};

export default connect(mapStateToProps)(Notifications);
